import * as Yup from 'yup';

export const ValidationSchemaForPricingConfigurator = Yup.object().shape({
    company_name: Yup.string().required('This field is required').max(30, 'Company name cannot exceed 30 characters'),
    sofr_rate: Yup.number()
        .required('This field is required')
        .min(0, 'SOFR rate cannot be less than 0')
        .max(100, 'SOFR rate cannot exceed 100')
        .test('is-decimal', 'SOFR rate must have up to 2 decimal places', (value) =>
            /^\d{1,3}(\.\d{1,2})?$/.test(value?.toString() || '')
        ),
    products: Yup.array().of(
        Yup.object().shape({
            product_ulid: Yup.string().required('This field is required'),
            global_calorific_value: Yup.number()
                .required('This field is required')
                .min(0, 'Calorific value cannot be less than 0')
                .test(
                    'is-decimal',
                    'Calorific value must have up to 2 decimal places and 10 digits before the decimal point',
                    (value) => /^\d{1,10}(\.\d{1,2})?$/.test(value?.toString() || '')
                ),
        })
    ),
});
